// extracted by mini-css-extract-plugin
export default {"container":"v5RxF","wrapper":"tyb5I","listItemMobile":"YILHr","pagination":"S6BPM","separator":"nLhd6"};